import { Component, input } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import {
  OnyxDatepickerComponent,
  OnyxSectionComponent,
  OnyxUploadComponent,
} from '@onyx/angular';

type FleetRegistrationCertificateFormGroup = ReturnType<
  (typeof FleetRegistrationCertificateFormComponent)['buildForm']
>;

@Component({
  selector: 'app-fleet-registration-certificate-form',
  imports: [
    OnyxSectionComponent,
    ReactiveFormsModule,
    OnyxDatepickerComponent,
    OnyxUploadComponent,
  ],
  templateUrl: './fleet-registration-certificate-form.component.html',
  styleUrl: './fleet-registration-certificate-form.component.scss',
})
export class FleetRegistrationCertificateFormComponent {
  public readonly form =
    input.required<FleetRegistrationCertificateFormGroup>();

  protected readonly I18N = 'fleet.fleetForm.registrationCertificate';

  public static buildForm(fb: NonNullableFormBuilder) {
    return fb.group({
      technicalInspectionExpiryDate: fb.control<string | null>(null, [
        Validators.required,
      ]),
      scan: fb.control<string[]>([]),
    });
  }
}
